import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';
import $ from 'static/script/libs/jquery';
import ShopItemSettingsModal from 'static/script/app/ui/shop-item-settings-modal';

function ShopItemSettingsAction() {
    this.defaultAttrs({
        settingsAction: '[data-shop-item-settings-action]',
        settingsModal: '[data-shop-item-settings-modal]'
    });

    this._getHtmlForModal = function() {
        return $('[data-shop-item-settings-modal-template]').html();
    };

    this._showModal = function(e) {
        e.preventDefault();
        e.stopPropagation();

        this.trigger(document, 'data:navigation:before-modal-load');

        let getQuotaSuccess = function(quota) {
            let modalHtml = this._getHtmlForModal();
            let payload = {
                content: modalHtml,
                cssClass:
                    'shop-item-settings-modal-container modal-background modal-default'
            };

            this.trigger(document, 'ui:modal:open', payload);

            let itemId = $(e.target)
                .parents('[data-item-id]')
                .data('item-id');
            let itemCard = $(e.target).parents('[data-item-card-body]');
            let onDisplay = itemCard.data('item-on-display');
            let priceBeforeDiscount = itemCard.data('price-before-discount');
            let discountRate = itemCard.data('discount-rate');
            let canHaveDiscount = itemCard.data('can-have-discount');

            ShopItemSettingsModal.attachTo(this.attr.settingsModal, {
                itemId: itemId,
                onDisplay: !!onDisplay,
                onDisplayCount: quota.onDisplayCount,
                maxOnDisplayCount: quota.maxOnDisplayCount,
                discountCount: quota.discountCount,
                maxDiscountCount: quota.maxDiscountCount,
                priceBeforeDiscount: priceBeforeDiscount,
                discountRate: discountRate,
                canHaveDiscount: !!canHaveDiscount
            });
        };

        this._get({
            url: '/profile/shop-item-settings/quotas',
            success: getQuotaSuccess.bind(this)
        });

        this.trigger(document, 'analytics:track-event', {
            category: 'Shop Item Settings',
            action: 'Clicked',
            label: ''
        });
    };

    this._closeModal = function(e) {
        this.trigger(document, 'ui:modal:close');
    };

    this._getItemCardBody = function(itemId) {
        return this.$node
            .find('[data-item-id=' + itemId + ']')
            .find('[data-item-card-body]')
            .first();
    };

    this._onDisplayChanged = function(evt, payload) {
        let itemCard = this._getItemCardBody(payload.itemId);
        itemCard.data('item-on-display', payload.onDisplay);

        this._updateRibbon(itemCard, payload.onDisplay);
    };

    this._discountChanged = function(evt, payload) {
        let itemCard = this._getItemCardBody(payload.itemId);
        itemCard.data('discount-rate', payload.discountRate);

        if (payload.hasDiscount) {
            itemCard
                .find('[data-item-card-details-discount-price]')
                .html(this._formatMoney(payload.discountPrice));
            itemCard
                .find('[data-item-card-details-price-before-discount]')
                .html(
                    this._formatMoney(itemCard.data('price-before-discount'))
                );
            itemCard
                .find('[data-item-card-discount-rate]')
                .html(payload.discountRate);
            itemCard.addClass('item-card-body-discount');
        } else {
            itemCard
                .find('[data-item-card-details-price]')
                .html(
                    this._formatMoney(itemCard.data('price-before-discount'))
                );
            itemCard.removeClass('item-card-body-discount');
        }
    };

    this._formatMoney = function(amount) {
        return amount + ' kr';
    };

    this._updateRibbon = function(itemCard, onDisplay) {
        let ribbons = itemCard.find('[data-item-ribbon]');
        let onDisplayRibbon = itemCard.find('[data-item-ribbon-on-display]');
        ribbons.addClass('hidden');
        if (onDisplay) {
            onDisplayRibbon.removeClass('hidden');
        } else if (itemCard.data('has-free-shipping')) {
            itemCard
                .find('[data-item-ribbon-free-shipping]')
                .removeClass('hidden');
        }
    };

    this.after('initialize', function() {
        this.on('click', {
            settingsAction: this._showModal
        });

        this.on(document, 'ui:shop-item-settings:on-display-changed', this._onDisplayChanged);
        this.on(document, 'ui:shop-item-settings:discount-changed', this._discountChanged);
        this.on(document, 'ui:feature-feedback:prompt', this._closeModal);
    });
}

export default defineComponent.component(ShopItemSettingsAction, WithAjax);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/shop-item-settings-action.js